module.exports = __webpack_public_path__ + "static/media/HireRectangle.55b6be19.svg";